export default __webpack_public_path__ + "static/media/graz1_dark.8dee29d5.png";